function formatPhoneNumber(phoneNumber: string) {
  // 하이픈 제거 및 숫자만 추출
  const digits = phoneNumber.replace(/\D/g, "");

  // 숫자 길이에 따라 하이픈 추가 또는 숫자만 반환
  if (phoneNumber.includes("-")) {
    // 이미 하이픈이 포함되어 있다면 숫자만 반환
    return digits;
  } else {
    // 숫자만 입력된 경우 하이픈을 추가하여 반환
    if (digits.length === 11) {
      // 11자리 번호, 보통 010으로 시작
      return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
    } else if (digits.length === 10) {
      // 10자리 번호, 지역번호 또는 010
      if (digits.startsWith("02")) {
        // 서울 지역번호인 경우
        return `${digits.slice(0, 2)}-${digits.slice(2, 6)}-${digits.slice(6)}`;
      } else {
        // 그 외 지역번호 또는 휴대폰
        return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
      }
    } else {
      // 예외적인 길이의 번호는 처리하지 않음
      return phoneNumber;
    }
  }
}

export default formatPhoneNumber;
